import { createContext } from 'react';
import { CouncilContext } from '../models/Elements';
import { Council } from '../models/Entities';

const CustomCouncilContext = createContext<CouncilContext>({
    council: {},
    setCouncil: (council: Council) => {}
});
export default CustomCouncilContext;
